import React from 'react';
import XlsxImportModal from '../../components/XlsxImportModal';
import { importSkus, SKU_IMPORT_TEMPLATE_PATH } from '../../api/material';

interface Props {
    open: boolean;
    onClose: () => void;
    /** 导入直接入库成功后回调 (走审批流时数据未变, 不触发) */
    onImported?: () => void;
}

// SKU 批量导入 (xlsx). 模板前 5 列与飞书《SKU归一更新清单》同构:
// SKU编号 / 产品中文名称 / 产品英文名称 / 材质编码 / 商品链接.
const SkuImportModal = ({ open, onClose, onImported }: Props) => (
    <XlsxImportModal
        open={open}
        onClose={onClose}
        onImported={onImported}
        title="批量导入 SKU (xlsx)"
        templatePath={SKU_IMPORT_TEMPLATE_PATH}
        templateName="sku-import-template.xlsx"
        upload={importSkus}
        hint={
            <>
                SKU 编号已存在的行按<b>更新</b>处理 —— 只覆盖表里填了值的列 (可用于成批补绑材质编码),
                空单元格不会清空存量值; 材质编码留空表示暂不绑定材料, 多个材质用逗号分隔 (一个 SKU 可绑多个材料,
                只追加绑定、不解除存量绑定)。
                末尾两列「规格类型」(编码或名称, 见 SKU 规格模板) 与「规格」(如 <code>长=300; 宽=200; 厚度=3</code>,
                字段写编码或名称, 可带单位): 属性为<b>原材料</b>的 SKU 必填 (按合并存量后的整行判, 只补绑材质编码的行不受影响);
                规格类型不变时只填几个字段即只改那几个。
            </>
        }
    />
);

export default SkuImportModal;
